<template>
  <div id="app">
    <Home/>
  </div>
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'app',
  components: {
    Home
  }
}
</script>

<style>
html{
  scroll-behavior: smooth;
}
#app {
  font-family: "Afacad", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
  color: #000;
}
.btn{
  outline: none !important; 
}
button:focus {
  outline:0 !important;
  box-shadow: none !important;
}
</style>
